import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, of, Subscription } from 'rxjs';
import { catchError, startWith, switchMap } from 'rxjs/operators';
import { ChallengeContextService } from '../shared/contexts/challenge-context/challenge-context.service';
import { DirectoryUser, ProfileDirectoryService } from '../shared/services/profile-routing/profile-directory.service';
import { ProfileInlineEditService } from './services/profile-inline-edit.service';
import { createFitnessProfilePreferences } from './user-profile.config';
import { DwSecurityUserService, DwMetaDataFormComponent } from '@devwareapps/devware-cap';

@Component({ selector: 'app-participant-profile', template: `<app-central-profile-context kind="streaker" [name]="data ? ((data.FirstName || '') + ' ' + (data.LastName || '')).trim() : ''"></app-central-profile-context><main>
  <app-profile-skeleton *ngIf="loading"></app-profile-skeleton><p *ngIf="error" role="alert">{{ error }}</p>
  <ng-container *ngFor="let scope of [formScope]; trackBy: trackFormScope">
  <dw-meta-data-form #profileForm *ngIf="data && !loading" item="UserProfile" [keyValue]="data.UserProfileId" [data]="data" [overrideData]="true"
    configKeyPart="participant-public-profile" [preferences]="preferences" [showButtons]="false"
    [allowConfiguration]="false" [handleRedirect]="false"></dw-meta-data-form>
  </ng-container>
  </main>`, styles: [`main {max-width:1200px;margin:auto;padding:1.5rem;}`] })
export class ParticipantProfileComponent implements OnDestroy {
    @ViewChild('profileForm') profileForm: DwMetaDataFormComponent;
    data: DirectoryUser; loading = true; error = '';
    // CAP forms do not reload on keyValue changes. Key the mounted view even
    // when cached profile reads start and finish within one change-detection pass.
    formScope = '';
    trackFormScope(_index: number, scope: string): string { return scope; }
    preferences = createFitnessProfilePreferences();
    private subscription: Subscription;
    constructor(route: ActivatedRoute, challenge: ChallengeContextService, directory: ProfileDirectoryService, security: DwSecurityUserService, private inline: ProfileInlineEditService) {
        this.preferences.readOnly = true;
        const sections = (this.preferences.section as any).sections;
        sections[0].config.participantView = true;
        this.subscription = combineLatest([route.paramMap, challenge.challengeChange$,
            security.securityContextChanged().pipe(startWith(null))]).pipe(switchMap(([params, selected]) => {
            this.data = null; this.error = ''; this.loading = true;
            this.formScope = JSON.stringify([params.get('slug'), selected.ChallengeDefinitionId,
                security.securityContext?.AuthenticatedUser?.UserId, security.securityContext?.ApplicationUser?.UserId]);
            if (!selected.ChallengeDefinitionId) { this.error = 'Select a challenge to view this profile.'; return of(null); }
            return directory.user(params.get('slug'), selected.ChallengeDefinitionId).pipe(
                catchError(error => { this.error = error.message || 'Unable to load profile.'; return of(null); }));
        })).subscribe(data => {
            this.data = data;
            const ownProfile = !!data?.UserId && data.UserId === security.securityContext?.ApplicationUser?.UserId;
            sections[1].sections[0].config.ownProfile = ownProfile;
            this.loading = false;
        });
    }
    canNavigate() { return this.inline.canNavigate(); }
    allowChallengeChange = () => this.canNavigate();
    ngOnDestroy(): void { this.subscription.unsubscribe(); }
}
